angular.module('unica_feedback_category.feedback_category_controllers')

.controller('FeedbackCategoryEditController', function(
	$rootScope, $scope, $state, $stateParams,
	FeedbackCategoryEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getFeedbackCategory( $stateParams.id );

	$scope.pageTitle = 'Modifica Categoria';

	$rootScope.feedbackCategoryData = {
		event_id: $stateParams.event_id,
		title: '',
		description: ''
	};

	$scope.tinymceOptionsReady = false;
	$scope.tinymceOptionsEmailBody = angular.copy($rootScope.tinymceOptionsEmailBody);
	$scope.tinymceOptionsReady = true;

	$scope.saveFeedbackCategory = function() {
		$scope.showLoader();

		var feedbackCategoryData = angular.copy($rootScope.feedbackCategoryData);

		FeedbackCategoryEditService
			.update(feedbackCategoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Feedback Categoria aggiornata con successo!', '');
					$state.go('app.feedback_category.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})
;